import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import { useField } from 'formik';

export interface SelectFieldOption {
  id: string;
  label: string;
  value: string | number;
}

export interface SelectFieldProps {
  name: string;
  label: string;
  options: SelectFieldOption[];
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export function SelectField({
  name,
  label,
  options,
  placeholder = 'Please select an option',
  disabled = false,
  className = '',
}: SelectFieldProps) {
  const [field, meta] = useField(name);
  const hasError = meta.touched && meta.error;
  const isPlaceholderSelected =
    field.value === '' || field.value === undefined || field.value === null;

  return (
    <div className={`flex w-full flex-col ${className}`}>
      <label
        htmlFor={name}
        className="font-nunito mb-2 text-base text-gray-900"
      >
        {label}
      </label>
      <select
        id={name}
        className={classNames(
          'focus:border-primary-600 focus:ring-primary-600 block w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-3 text-base focus:outline-none focus:ring-1',
          {
            'border-red-500 bg-red-50': hasError,
            'text-gray-400': isPlaceholderSelected,
            'text-gray-900': !isPlaceholderSelected,
          }
        )}
        disabled={disabled}
        {...field}
      >
        <option value="" className="text-gray-400">
          {placeholder}
        </option>
        {options.map((option) => (
          <option
            key={option.id}
            value={option.value}
            className="text-gray-900"
          >
            {option.label}
          </option>
        ))}
      </select>

      {hasError && (
        <div className="font-nunito mt-2 flex items-start text-base text-red-500">
          <ExclamationCircleIcon className="h-5 w-5" />
          <span className="ml-1">{meta.error}</span>
        </div>
      )}
    </div>
  );
}
